import { Component, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { accountsToFilterOut } from 'src/app/authentication/state/authentication.selector';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { Privileges } from 'src/app/privileges/privileges';
import { DeviceRegister } from '../../device-register';
import { DevicesFilterOption } from '../../models/device-filter-option';
import { DeviceRegisterListItem } from '../../models/device-register-results.model';
import * as DeviceDetailActions from 'src/app/pages/device-details/state/device-detail.actions';
import { DeviceDetailSaveEvent } from 'src/app/pages/device-details/models/device-detail-form-submit-event';
import {
   changeSipUserPasswords,
   rebootPhone,
   resetPhoneZtp,
} from '../../state/device-register.actions';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-system-device-register',
    templateUrl: './system-device-register.component.html',
    standalone: false
})
export class SystemDeviceRegisterComponent extends DeviceRegister {
   constructor(public store: Store) {
      super(store);
      this.store
         .select(accountsToFilterOut(Privileges.ManageDevices_View))
         .pipe(
            map((accountIds: number[]) => {
               if (accountIds.length > 0) {
                  const filters: DevicesFilterOption[] = [
                     {
                        field: 'AccountId',
                        operation: FilterOperations.NotIn,
                        type: 'numeric',
                        value: accountIds,
                     },
                  ];
                  return filters;
               }
               return [];
            })
         )
         .subscribe((filters: DevicesFilterOption[]) => {
            this.filters = filters;
            this.columns = [
               'account',
               'deviceModel',
               'macAddress',
               'sipUser',
               'lastDateProvisioned',
               'defaultPhoneNumber',
               'ztpRegistered',
               'connectionStatus',
               'lastConnected',
               'devicesActionsMenu',
            ];
         });
   }

   onResetHackedAndFraud(device: DeviceRegisterListItem) {
      const hackedAndFraudSipUserIds = device.hackedAndFraudSipUserIds;

      if (
         hackedAndFraudSipUserIds !== null &&
         hackedAndFraudSipUserIds !== undefined &&
         hackedAndFraudSipUserIds.length > 0
      ) {
         this.store.dispatch(changeSipUserPasswords({ sipUserIds: hackedAndFraudSipUserIds }));
      }
   }

   onRebootPhone(deviceId: number) {
      this.store.dispatch(rebootPhone({ deviceId: deviceId }));
   }

   onResetPhoneZtp(deviceId: number) {
      this.store.dispatch(resetPhoneZtp({ deviceId: deviceId }));
   }

   onReleaseFromExtension(device: DeviceRegisterListItem) {
      if (device.deviceId) {
         this.store.dispatch(
            DeviceDetailActions.releaseDeviceToAccount({ deviceId: device.deviceId })
         );
      }
   }

   onReleaseToSystemInventory(event: DeviceDetailSaveEvent) {
      this.store.dispatch(DeviceDetailActions.releaseDeviceDetail(event));
   }

   onDeleteDevice(event: DeviceDetailSaveEvent) {
      this.store.dispatch(DeviceDetailActions.deleteDevice({deviceId: event.device?.deviceId!}));
   }
}
